<script>
import _ from 'lodash'
import BaseSmartInput from './BaseSmartInput'
/**
 * child component of {@link BaseSmartInput}. is used in AdvancedOptions (options: "Keyword" and "Url" if operator is "Exactly matching")
 * This component involves more tricky logic because each entered letter followed by API call that provides new options list
 */
export default {
  name: 'BaseSmartInputAutocomplete',
  extends: BaseSmartInput,
  /**
   * next methods override corresponding parent methods
   */
  methods: {
    // we don't have predefined options in autocomplete mode so we should get it from modelValue
    getSelectedOptions () {
      const value = _.get(this.modelValue, 'value', null)
      if (value) {
        return {
          value,
          label: value
        }
      }
      return {}
    },
    optionsHandler () {
      this.filteredOptions = _.cloneDeep(this.options)
      this.filterOptions()
    },
    textHandler () {
      if (this.isOpened) {
        this.$emit('input-text', this.text)
        this.selectedOption = {}
        if (this.easyModel) this.$emit('change', this.easyModel ? '' : { value: '', text: '' })
      }
    },
    open () {
      this.$emit('state', 'open')
      this.isOpened = true
      this.setListStyle()
    },
    changeModel () {
      this.text = this.selectedOption && this.selectedOption.label ? this.selectedOption.label : this.text
      const value = this.selectedOption ? this.selectedOption.value : ''
      if (value || this.easyModel) this.$emit('change', this.easyModel ? this.text || '' : { value, text: this.text })
      this.$emit('apply')
    },
    select (option) {
      this.selectedOption = _.cloneDeep(option)
      this.$emit('input-text', this.selectedOption.label)
      this.close()
    }
  }
}
</script>
